import { render, staticRenderFns } from "./AssetViewTable.vue?vue&type=template&id=5d667540&scoped=true"
import script from "./AssetViewTable.vue?vue&type=script&lang=ts"
export * from "./AssetViewTable.vue?vue&type=script&lang=ts"
import style0 from "./AssetViewTable.vue?vue&type=style&index=0&id=5d667540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d667540",
  null
  
)

export default component.exports